import React, { useContext } from 'react';
import { ReactComponent as IconClose } from '../../../svg/icon_close.svg';
import { ReactComponent as IconTick } from '../../../svg/icon_tick.svg';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';

import moment from 'moment';

const iconTickStyle = {
    width: 70,
    height: 24,
    verticalAlign: 'bottom',
    float: 'left',
    marginLeft: '0.5vw',
    fill: '#3B893A'
};

const iconCloseStyle = {
    width: 70,
    height: 54,
    verticalAlign: 'bottom',
    float: 'left',
    marginLeft: '0.5vw'
};

const AvailsCell = ({
    data,
    fieldName,
    compareFieldName,
    isStandardAirtimeField
}) => {
    const { dateFormat } = useContext(SystemSettingsContext);

    const availability = () => {
        if (data[isStandardAirtimeField]) return '-';
        if (data[fieldName] && data[fieldName] === data[compareFieldName])
            return <IconTick style={iconTickStyle} />;
        if (data[fieldName] === null)
            return <IconClose style={iconCloseStyle} />;

        return data[fieldName] ? (
            <>
                <label style={{ color: '#D90000' }}>
                    {moment(data[fieldName]).format(`${dateFormat}`)}
                </label>
            </>
        ) : (
            '-'
        );
    };

    return (
        <div style={{ textAlign: 'left', padding: '0px 10px' }}>
            {availability()}
        </div>
    );
};

export default AvailsCell;
